import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const productModule = {
  namespaced: true,
  state: {
    products: null,
    product: null,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  mutations,
  actions,
  getters,
};

export default productModule;
